export const TESTIMONIALS = [
  {
    name: "Margaret Whitman",
    role: "General Counsel, DC Law Firm",
    quote:
      "USA Limo Service has been our firm's preferred transportation since 2018. Their chauffeurs are punctual, discreet, and impeccably professional. Indispensable for client visits.",
  },
  {
    name: "Daniel Park",
    role: "VP Operations, Federal Contractor",
    quote:
      "From Reagan pickups to executive roadshows, the experience is flawless every single time. The fleet is pristine and the dispatch team is on top of every detail.",
  },
  {
    name: "Sophia Almeida",
    role: "Event Director, Embassy of Brazil",
    quote:
      "We rely on USA Limo for dignitary transfers and gala logistics. Their armed security chauffeurs and motor coaches handled a 200-guest gala without a single hiccup.",
  },
  {
    name: "Robert Anderson",
    role: "CEO, Tysons Tech Group",
    quote:
      "Forty years in the business shows. Their executive chauffeur service literally lets me work on the way to Dulles. Best transportation decision we've ever made.",
  },
];
